export enum Role {
  SuperAdmin = 'ROLE_SUPER_ADMIN',
  Admin = 'ROLE_ADMIN',
  User = 'ROLE_USER',
}
